import { render, staticRenderFns } from "./headerCatering.vue?vue&type=template&id=54b3d028&scoped=true&"
import script from "./headerCatering.vue?vue&type=script&lang=js&"
export * from "./headerCatering.vue?vue&type=script&lang=js&"
import style0 from "./headerCatering.vue?vue&type=style&index=0&id=54b3d028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3d028",
  null
  
)

export default component.exports